export default __webpack_public_path__ + "static/media/anthem-website-logos_omidyar-network.739f138b.webp";